import ApiService from "../../../ApiService";

const ListService = {
    loadScreenView: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/book/list/loadscreenview", { searchVO }, successCallback, failureCallback);
    },
    delete: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/book/list/delete", { id }, successCallback, failureCallback);
    },
};

export default ListService;